import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Register from './components/Register/register';
import Login from './components/Login/login';
import Instructions from './components/Instructions/instructions';
import Questions from './components/Question/question';
import Admin from './components/Admin/admin';
import ThankYou from './Thankyou/thankyou';
import PrivateRoute from './utils/privateroute';

const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    || window.innerWidth <= 768;
};

const MobileBlock = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#0d1b2a',
    color: 'white',
    textAlign: 'center',
    padding: '30px',
  }}>
    <div style={{ fontSize: '80px', marginBottom: '20px' }}>📵</div>
    <h1 style={{ color: '#ffa500', fontSize: '26px', marginBottom: '16px' }}>Mobile Device Not Allowed</h1>
    <p style={{ fontSize: '16px', lineHeight: '1.8', maxWidth: '320px', color: '#ccc' }}>
      This exam is not accessible on mobile phones or tablets.<br /><br />
      Please use a <strong style={{ color: 'white' }}>desktop or laptop computer</strong> to access the exam portal.
    </p>
    <div style={{ marginTop: '30px', padding: '12px 24px', backgroundColor: '#ffa500', borderRadius: '8px', fontWeight: 'bold', color: '#000' }}>
      EvaluTech Exam Portal
    </div>
  </div>
);

const App = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileDevice());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) return <MobileBlock />;

  const handleLogin = () => setAuthenticated(true);
  const handleLogout = () => setAuthenticated(false);


  return (
    <Router>
      <Routes>
      <Route path="/register" element={<Register />} />
      <Route
        path="/instructions"
        element={<PrivateRoute element={<Instructions />} authenticated={authenticated} />}
      />
      <Route
        path="/questions"
        element={<PrivateRoute element={<Questions />} authenticated={authenticated} />}
      />
      <Route path="/admin" element={<PrivateRoute element={<Admin />} authenticated={authenticated} />} />
      <Route
        path="/thankyou"
        element={<PrivateRoute element={<ThankYou />} authenticated={authenticated} />}
      />
      <Route
        path="/"
        element={<Login onLogin={handleLogin} authenticated={authenticated} onLogout={handleLogout} />}
      />
      <Route
        path="/login"
        element={<Login onLogin={handleLogin} authenticated={authenticated} onLogout={handleLogout} />}
      />
      </Routes>
    </Router>
  );
};

export default App;
